import React from 'react';
import Presenter from './Presenter';
import MobilePresenter from './MobilePresenter';
import Container from './Container';
import {Default,Mobile} from '../../Sizes';
import ErrorPresenter from './ErrorPresenter';


const QuizList = (props) => {
	return <Container 
		{...props}
		render={({error,...containerProps},other)=>{
			if(error){
				return (<ErrorPresenter error={error}
					{...other}
				/>);
			}
			return (
				<React.Fragment>
					<Default>
						<Presenter 
							{...containerProps}
							{...other}
						/>
					</Default>
					<Mobile>
						<MobilePresenter 
							{...containerProps}
							{...other}
						/>
					</Mobile>
				</React.Fragment>
			);
		}}
	/>;
};
export default QuizList;